var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main container" },
    [
      _vm.showBackButton
        ? _c("div", { staticClass: "back-btn", on: { click: _vm.back } }, [
            _c("i", { staticClass: "fas fa-angle-left" }),
            _vm._v(" "),
            _c("span", [
              _vm._v("\n      " + _vm._s(_vm.$t("button.back")) + "\n    ")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-12 text-center" }, [
        _c("p", { staticClass: "text-header highlight-color" }, [
          _vm._v("\n      " + _vm._s(_vm.textHeader) + "\n    ")
        ])
      ]),
      _vm._v(" "),
      _c("StepProgress", {
        class: "custom-step-progress",
        attrs: { steps: _vm.steps, active: _vm.active }
      }),
      _vm._v(" "),
      _vm.loading
        ? _c("BasePaymentForm", {
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function() {
                    return [_c("BaseLoading")]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              2086913995
            )
          })
        : _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-20239fb2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20239fb2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BasePayment.vue
// module id = null
// module chunks = 